import { Panel } from "../../../components/panels/Panel";
import { useGetData } from "../../../services/api/api-tools";
import { Loader } from "../../../components/loading/Loader";
import { useMemo } from "react";


export const ErgonomicsNotifications = () => {

  const notifications = useGetData('notifications', 'notifications');

  const [oldNotifications, newNotifications] = useMemo(() => {
    if (notifications.isLoading) return [[], []];

    const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;
    const now = Date.now();

    return notifications.data.sort((a, b) => b.creation_date - a.creation_date).reduce(
      (acc, item) => {
        const createdAt = new Date(item.creation_date).getTime() * 1000;
        if (now - createdAt > ONE_WEEK_MS) {
          acc[0].push(item);
        } else {
          acc[1].push(item);
        }
        return acc;
      },
      [[], []]
    );
  }, [notifications]);

  if (notifications.isLoading) return <Loader />;

  return (
    <Panel title="NOTIFICATIONS">
      <div className='h-full bg-perception-black-800 overflow-y-auto'>
        {
          <>
            {
              newNotifications.map((notification) => {
                const borderClass = parseInt(notification.type) === 0 ? 'border-l-red-500' : 'border-l-yellow-500';
                return (
                  <div className={`border-l-4 bg-perception-black-700 ${borderClass} p-4 my-4 text-sm`}>
                    {notification.content}
                  </div>
                )
              })
            }
            {
              newNotifications.length === 0 &&
                <div className='flex flex-col items-center'>
                  <span className='text-perception-black-700 text-8xl material-icons my-4'>notifications_off</span>
                  <span className='text-perception-gray-700 text-center'>Pas de nouvelle notification</span>
                </div>
            }
          </>
        }
        {
          oldNotifications.length > 0 &&
            <>
              <h2 className='mt-8'>Anciennes notifications</h2>
              {
                oldNotifications.map((notification) => {
                  console.log(notification);
                  const borderClass = parseInt(notification.type) === 0 ? 'border-l-red-500' : 'border-l-yellow-500';
                  return (
                    <div className={`border-l-4 bg-perception-black-700 ${borderClass} p-4 my-4 text-sm`}>
                      {notification.content}
                    </div>
                  )
                })
              }
            </>
        }
      </div>
    </Panel>
  );
};